let config = {
  api_oauth_client_id: 5,
  api_oauth_client_secret: 'v9mGTYWLcPUFjm0sZUs9rF9VSKESvUtFWLNkOzfZ',

  api_oauth_url_authorize: '/oauth/authorize',
  api_oauth_url_token: '/oauth/token',

  api_oauth_grant_type: 'password',
  api_oauth_default_scope: 'api-main-create api-main-read api-main-update api-main-delete',

  sendbird_app_id: '7F917A67-D6FD-4E56-944D-8D58E5BCF1BE',

  default_avatar_url: 'https://statelegitimacy.files.wordpress.com/2013/01/anonymous.png',

  api_host: 'https://api.directfuneral.app'
}

export default config



// WEBPACK FOOTER //
// ./src/config/config.js